export const TOOLTIP_STYLE = {
  contentStyle: {
    background: 'white',
    border: '1px solid #e2e8f0',
    borderRadius: 0,
    fontSize: 14,
    padding: '8px 12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  cursor: { fill: 'rgba(37, 99, 235, 0.06)' },
}

export const AXIS_STYLE = {
  tick: { fontSize: 13, fill: '#64748b' },
  stroke: '#cbd5e1',
}

// Primary blue palette for charts
export const CHART_COLORS = {
  primary: '#2563eb',
  primaryLight: '#60a5fa',
  secondary: '#60a5fa',
  muted: '#94a3b8',
  success: '#059669',
  warning: '#d97706',
}
